export default "__VITE_ASSET__BDmnydEH__"